import { render } from "./CapitalBeauty.vue?vue&type=template&id=d14c2b5c"
import script from "./CapitalBeauty.vue?vue&type=script&lang=js"
export * from "./CapitalBeauty.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__